export const allowedWebsiteTypes = ["all", "egp"]